export default __webpack_public_path__ + "static/media/ic_slovenia.3026e70d.svg";